import { reactive } from "@vue/composition-api";
import _axios from "@/axios";

export function useMigrationPortal() {
  const migrationPortalData = reactive({
    isMigrationSucess: false,
    isMigrationError: false,
    isClientPortalMigrable: { facebook: false, pms: false },
    isGroupMigrable: { facebook: false, pms: false },
  });

  function migrateClientPortal(clientId, portalProfile = null) {
    const params = new URLSearchParams({});
    if (portalProfile != null) {
      params.set("new_portal_profile_id", portalProfile);
    }

    return _axios
      .post("/client-portal-migration/" + clientId + "?" + params.toString())
      .then(() => {
        migrationPortalData.isMigrationSucess = true;
        location.reload();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function migrateClientPortalV3ToV5(clientId) {
    return _axios
      .post("/client-portal-migration-v3/" + clientId)
      .then(() => {
        migrationPortalData.isMigrationSucess = true;
        location.reload();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function migrateGroup(groupId, portalProfile = null) {
    const params = new URLSearchParams({});
    if (portalProfile != null) {
      params.set("new_portal_profile_id", portalProfile);
    }
    return _axios
      .post("/group-migration/" + groupId + "?" + params.toString())
      .then(() => {
        migrationPortalData.isMigrationSucess = true;
        location.reload();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function migrateGroupV3ToV5(groupId) {
    return _axios
      .post("/group-migration-v3/" + groupId)
      .then(() => {
        migrationPortalData.isMigrationSucess = true;
        location.reload();
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function clientPortalIsMigrable(clientId) {
    return _axios
      .get("/client-portal-is-migrable/" + clientId)
      .then((response) => {
        migrationPortalData.isClientPortalMigrable = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  function groupIsMigrable(clientId) {
    return _axios
      .get("/group-is-migrable/" + clientId)
      .then((response) => {
        migrationPortalData.isGroupMigrable = response.data.data;
      })
      .catch(() => {
        alert(
          "Une erreur est survenue, si cela se reproduit contactez le support"
        );
      });
  }

  return {
    migrationPortalData,
    migrateClientPortal,
    migrateGroup,
    migrateClientPortalV3ToV5,
    migrateGroupV3ToV5,
    clientPortalIsMigrable,
    groupIsMigrable,
  };
}
